module.exports = __webpack_public_path__ + "img/smtp_mail_multi.40d9a997.svg";